@if (filterDisplayStore.isDialogOpen()) {
<div class="fixed inset-0 z-50 overflow-y-auto">
  <div
    class="fixed inset-0 bg-white/70 backdrop-blur-sm"
    (click)="onCancel()"
    aria-hidden="true"
  ></div>

  <div
    class="relative flex min-h-screen items-end justify-center px-4 pb-20 pt-4 text-center sm:block sm:p-0"
  >
    <span class="hidden sm:inline-block sm:h-screen sm:align-middle"
      >&#8203;</span
    >

    <div
      class="inline-block w-full transform rounded-lg border border-gray-200 bg-white pb-4 text-left align-bottom shadow-xl transition-all sm:my-8 sm:max-w-3xl sm:align-middle"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
      tabindex="0"
      role="dialog"
      aria-modal="true"
      aria-labelledby="payment-filter-dialog-title"
    >
      <div class="rounded-t-lg bg-slate-600 px-4 pb-3 pt-5 sm:px-6 sm:pt-4">
        <div class="flex items-center justify-between">
          <h3
            id="payment-filter-dialog-title"
            class="text-lg font-medium text-slate-100"
          >
            Payment Filters
          </h3>
          <lib-close-icon-button
            size="sm"
            variant="modal"
            colorScheme="dark"
            title="Close payment filters"
            ariaLabel="Close payment filters"
            (clicked)="onCancel()"
          />
        </div>
      </div>

      <div class="flex flex-col gap-y-6 px-4 pb-2 pt-4 sm:px-6">
        <div class="flex flex-col gap-y-4">
          <div>
            <h3 class="text-sm font-medium text-gray-900">Payment</h3>
            <p class="mt-1 text-sm text-gray-500">
              Filter payments by type and payment method.
            </p>
          </div>

          <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
            <div class="flex flex-col gap-y-1">
              <label
                for="commission-payment-type"
                class="text-sm font-medium text-gray-700"
                >Payment Type</label
              >
              <select
                id="commission-payment-type"
                class="block w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm focus:border-orange-500 focus:outline-none focus:ring-1 focus:ring-orange-500"
                [value]="filterDisplayStore.draftFilters().paymentType"
                (change)="
                  filterDisplayStore.setPaymentType($any($event.target).value)
                "
              >
                @for (opt of paymentTypeOptions; track opt.value) {
                <option [value]="opt.value">{{ opt.label }}</option>
                }
              </select>
            </div>

            <div class="flex flex-col gap-y-1">
              <label
                for="commission-payment-method"
                class="text-sm font-medium text-gray-700"
                >Payment Method</label
              >
              <select
                id="commission-payment-method"
                class="block w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm focus:border-orange-500 focus:outline-none focus:ring-1 focus:ring-orange-500"
                [value]="filterDisplayStore.draftFilters().paymentMethod"
                (change)="
                  filterDisplayStore.setPaymentMethod($any($event.target).value)
                "
              >
                @for (opt of paymentMethodOptions; track opt.value) {
                <option [value]="opt.value">{{ opt.label }}</option>
                }
              </select>
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-y-4">
          <div>
            <h3 class="text-sm font-medium text-gray-900">Organizations</h3>
            <p class="mt-1 text-sm text-gray-500">
              Filter payments by payee and payer organizations.
            </p>
          </div>

          <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
            <lib-organization-selection-input
              label="Payee Organization (Optional)"
              placeholder="Select payee organization..."
              [selectedOrganization]="
                filterDisplayStore.draftFilters().payeeOrganization
              "
              (organizationSelected)="
                filterDisplayStore.setPayeeOrganization($event)
              "
              (organizationCleared)="
                filterDisplayStore.setPayeeOrganization(null)
              "
            />

            <lib-organization-selection-input
              label="Payer Organization (Optional)"
              placeholder="Select payer organization..."
              [selectedOrganization]="
                filterDisplayStore.draftFilters().payerOrganization
              "
              (organizationSelected)="
                filterDisplayStore.setPayerOrganization($event)
              "
              (organizationCleared)="
                filterDisplayStore.setPayerOrganization(null)
              "
            />
          </div>
        </div>

        <div class="flex w-full justify-between gap-3">
          <shared-outlined-submit-button
            buttonText="Clear"
            (buttonClick)="onClear()"
          />

          <div class="flex gap-3">
            <button
              type="button"
              class="inline-flex items-center justify-center rounded-md bg-orange-600 px-4 py-2 text-sm font-medium text-white hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2"
              (click)="onApply()"
            >
              Apply Filters
            </button>

            <shared-cancel-button text="Cancel" (cancelled)="onCancel()" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}
